"use client";

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import cx from 'classnames'

import styles from "./styles.module.scss";

import Button from "../lms/ButtonComponent";

import { BUTTON_VARIANTS } from "../lms/constant";

// import ProgressBar from "../../../shared/LinearProgressBar";

import UploadIcon from '../../../assets/images/upload-icon.svg';
import ArrowIcon from '../../../assets/images/arrow-right-icon.svg';
import InfoIcon from '../../../assets/images/info-icon.svg';
import StarIcon from '../../../assets/images/star-icon.svg';
import LockIcon from '../../../assets/images/lock-icon.svg';
import DocIcon from '../../../assets/images/doc-icon.svg';
import Upload from '../../../assets/images/upload-blue-icon.svg';

import { useGetFinalAssessmentDetails } from './queries';
import StatusBanner from './StatusBanner';
import CreScoreHighlightCard from './CREScoreCard';
import { WEIGHTAGE } from './constant';

import DocumentUploadModal from './DocumentUploadModal';
import CameraModal from './CameraModal';
import { FINAL_ASSESSMENT_ALLOWED } from '../../../utils/cookiesmanager';

import ScoreProgress from './ScoreProgress';
import Shimmer from '../lms/ShimmerComponent';
import SuccessModal from './SuccessModal';
import { useGetTranslatedText } from '../lms/queries';
import { getTranslatedText } from '../../../utils/getTranslatedText';


const FinalAssessment = () => {
  const [openDocumentModal , setOpenDocumentModal] = useState(false);
  const [openCamera , setOpenCamera] =  useState(false);
  const [documentUploadSuccessfully , setDocumentUploadedSuccessfully] = useState(false)

  const [files, setFiles] = useState([]);
  const userId = localStorage.getItem('id');

  const navigate = useNavigate();

  const {data , isLoading , isFetching} = useGetFinalAssessmentDetails(userId);

  const {response} = data?.data || {};

  const {
    uploadButton, 
    documentUploaded, 
    documentReview, 
    startAssessment , 
    questionCount, 
    passingScore, 
    userAssessmentScore,
    tryAgainAssessment,
    overAllScoreCRE
    } = response || {};
  
  const handleUploadDocumentation = () => {
    setOpenDocumentModal(true);
  }

  const handleAssessmentRedirection = () => {
    sessionStorage.setItem(FINAL_ASSESSMENT_ALLOWED,"true");
    navigate('/user/final-assessment-question')
  }

  const languageId = localStorage.getItem("l_id") || 1;
  
  const { data: translatedTextResponse } = useGetTranslatedText(languageId);
  
  const { data: translatedText = [] } = translatedTextResponse || {};

  const handleClose = () => {
    setOpenCamera(false)
    setOpenDocumentModal(true);
  }

  const assessmentScore = Number(userAssessmentScore?.replace('%',''));
  const passingScoreValue = Number(passingScore?.replace('%',''));

  return (
    <>
    {
      isLoading || isFetching
      ?
      <Shimmer width='90%' height='100vh' style={{margin:'10px auto'}} borderRadius='16px' />
      :
      <div className={styles.wrapper}>
      {/* Student Progress Documentation */}
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.icon}>
            <img className={styles.svg} src={Upload} alt="Upload Icon" />
          </div>
          <div>
            <h3 className={styles.heading}>
              {
              getTranslatedText(
                translatedText,
                "student_progress_documentation",
                "Student Progress Documentation",
              )}
              </h3>
            <p className={styles['sub-heading']} >
              {
                getTranslatedText(
                translatedText,
                "tv_student_desc",
                "Submit evidence of your work with a student",
              )
              }
              </p>
          </div>
        </div>
       {(documentUploaded === 1 || documentReview === 1 || documentReview === 2) && <StatusBanner status={documentReview} />}
       { documentUploaded !== 1 && documentReview !== 1 && documentReview !== 2 && 
        <div className={styles.infoBox}>
          <img className={styles.img} src={InfoIcon} alt='' /> 
          <div className={styles.content}>
            <span className={styles.locked}>
              {
              getTranslatedText(
                translatedText,
                "locked_label",
                "Locked",
              )
            }
            </span> 
            {": "}
            <p style={{textAlign:'start'}}>
              {
              getTranslatedText(
                translatedText,
                "locked_description",
                "Complete the Learning Difficulties course and one student screening process to unlock upload documentation.",
              )
            }
            </p>
        </div>
        </div>}
          { documentReview !== 1 &&
           <Button
            label={uploadButton === 2 ?
              getTranslatedText(
                translatedText,
                "key_re_upload_document",
                "Re-upload File",
              ) 
               : 
              getTranslatedText(
                translatedText,
                "upload_document_cre",
                "Upload Documentation",
              )
              
            }
            buttonVariant={BUTTON_VARIANTS.PRIMARY}
            disabled={uploadButton === 0 || documentUploaded === 1}
            className={styles['upload-btn']}
            endIcon={<img src={UploadIcon} alt="upload-icon" />}
            onClick={handleUploadDocumentation}
            />
          }
      </div>

      {/* Final Assessment */}
      <div className={styles['final-assessment']}>
        <div className={styles.headerRow}>
          <div className={styles.header}>
            <div className={styles.icon}><img src={DocIcon} alt='' /></div>
            <h3 className={styles['final-assessment-text']}>
              {
                getTranslatedText(
                translatedText,
                "final_assessment",
                "Final Assessment",
              )
              }
              </h3>
          </div>

          {
          assessmentScore > passingScoreValue ? 
          <span className={styles['pass-tag']}>
            {
                getTranslatedText(
                translatedText,
                "key_pass",
                "Pass",
              )
              }
            </span>
           : 
           documentReview === 1 ? null : 
           <span className={styles.lockTag}><img className={styles.img} src={LockIcon} alt=''  />
            {
              getTranslatedText(
                translatedText,
                "locked_label",
                "Locked",
              )
            }
           </span>
          }
        </div>
{
  assessmentScore >= passingScoreValue
  ?
  <ScoreProgress score={userAssessmentScore} />
  :
  <>
    <div className={styles.grid}>
          <div className={styles.statBox}>
            <p className={styles['question-text']}>
              {
                getTranslatedText(
                translatedText,
                "questions",
                "Questions",
              )
              }
              </p>
            <h2 className={styles.count}>{questionCount}</h2>
          </div>

          <div className={styles.statBox}>
            <p className={styles['question-text']}>
              {
                getTranslatedText(
                translatedText,
                "passing_score",
                "Passing Score",
              )
              }
              </p>
            <h2 className={styles.count}>{passingScore}</h2>
          </div>
        </div>
        <p className={styles.points}><img src={StarIcon} alt="" />
        {
          getTranslatedText(
                translatedText,
                "cre_points_earned_for_completion",
                "CRE Points earned for completion",
          )
        }
        </p>
      {
       documentReview !== 1 && 
       <div className={cx(styles.infoBox,styles.info)}>
           <img className={styles.img} src={InfoIcon} alt='' /> 
           <div className={styles.content}>
            <span className={styles.locked}>
              {
                getTranslatedText(
                translatedText,
                "locked_label",
                "Locked :",
              )
              }
              </span> 
              {":"}
           <p style={{textAlign:'start'}}> 
             {
              getTranslatedText(
                translatedText,
                "desc_start_assessment",
                "This assessment unlocks after Student documentation approval.",
              )
              }
            </p>
        </div>
        </div>
        
      }
      <Button
            label={ tryAgainAssessment ===1 ?
               getTranslatedText(
                translatedText,
                "key_retry_assessment",
                "Re-Try Assessment",
              )  
              :
              getTranslatedText(
                translatedText,
                "start_assessment",
                "Start Assessment",
              )
            }
            buttonVariant={BUTTON_VARIANTS.PRIMARY}
            disabled={documentReview !== 1}
            className={styles['upload-btn']}
            // className={styles["exit-button"]}
            endIcon={<img src={ArrowIcon} alt="upload-icon" />}
            onClick={handleAssessmentRedirection}
      />
  </>
}
      </div>
      {
        assessmentScore >= passingScoreValue 
        &&
        <CreScoreHighlightCard 
        score={overAllScoreCRE} 
        message={
          getTranslatedText(
                translatedText,
                "cre_score_desc",
                `You have successfully completed the CRE programme. 
          Your details are being shared with RCI for the credit of 50 CRE points.`,
              )
        }
        isEligible
        data={WEIGHTAGE}
        />
      }
    </div>
    }

    {openDocumentModal && <DocumentUploadModal setFiles={setFiles} files={files} setOpenDocumentModal={setOpenDocumentModal} setDocumentUploadedSuccessfully={setDocumentUploadedSuccessfully} setOpenCamera={setOpenCamera}  />}
    {
      openCamera && <CameraModal files={files} setFiles={setFiles} onClose={handleClose} setOpenDocumentModal={setOpenDocumentModal}  />
    }
    {documentUploadSuccessfully && <SuccessModal setDocumentUploadedSuccessfully={setDocumentUploadedSuccessfully} />}
    </>
  );
};

export default FinalAssessment;